import { Injectable } from '@angular/core';
import { AbstractControl, UntypedFormArray, UntypedFormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';
import { SectionType } from 'enums-lib';
import { ISharedTemplateFeatures } from '../workflow-config.component';

@Injectable({ providedIn: 'root' })
export class AwesomedocWorkflowConfigService implements ISharedTemplateFeatures {
  get sectionValidators(): ValidatorFn {
    return this.atLeastOneTemplateSectionValidator();
  }

  get dynamicSectionsToInclude(): SectionType[] {
    return [SectionType.File, SectionType.Merge];
  }

  get autoFillSections(): SectionType[] {
    // according to the PM we automatically add up to a maximum of one section (of each type)
    return [
      SectionType.OutputFileName,
      SectionType.OutputFileType,
      SectionType.DocxTemplate,
      SectionType.HtmlDocxTemplate,
      SectionType.File,
      SectionType.Merge,
    ];
  }

  private atLeastOneTemplateSectionValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const sectionsFormArray = control as UntypedFormArray;
      const configFormGroup = control.parent as UntypedFormGroup;
      const useAsTemplate = configFormGroup?.get('useAttachmentsAsTemplate')?.value;

      // If using attachment as template, check if attachment section is required
      if (useAsTemplate) {
        const attachmentSection = sectionsFormArray.controls.find((fg: UntypedFormGroup) => {
          return fg.get('type').value === SectionType.File;
        }) as UntypedFormGroup;

        const isAttachmentRequired = attachmentSection?.get('required')?.value;
        return isAttachmentRequired ? null : { invalid: true };
      }

      // Original validation - check for DOCX template with file uploaded
      const ok = sectionsFormArray.controls
        .filter((fg: UntypedFormGroup) => {
          const type = fg.get('type').value;
          return type === SectionType.DocxTemplate;
        })
        .some((fg: UntypedFormGroup) => fg.get('sourceValue').value !== null);

      return ok ? null : { invalid: true };
    };
  }

  get signatureCombinedOutputDefault(): boolean {
    return false;
  }
}
